import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

import { useGoogleRecaptchaV3 } from '@pflegia/ui/hooks/use-google-recaptcha-v3';

import { UPDATE_CANDIDATE_NOTIFICATIONS } from '@shared/graphql/mutations';

export const useUpdateWhatsAppNotifications = () => {
  const { setRecaptchaToken } = useGoogleRecaptchaV3();
  const [updateCandidateNotifications, { loading }] = useMutation(UPDATE_CANDIDATE_NOTIFICATIONS);

  const updateWhatsAppNotifications = useCallback(
    async (value: boolean | null) => {
      await setRecaptchaToken('updateCandidateNotifications');
      await updateCandidateNotifications({ variables: { field: 'whatsAppNotifications', value } });
    },
    [setRecaptchaToken, updateCandidateNotifications],
  );

  return { loading, updateWhatsAppNotifications };
};
